import getVariation from "./getVariation";

export default function getComponentName(
    moduleVariation: string,
    moduleType: string
) {
    const { variation, type } = getVariation(moduleVariation, moduleType);

    return getCamelCase(`_${type}${variation && `_${variation}`}`);
}

function getCamelCase(componentName: string) {
    return componentName.replace(/_./g, (c) => c.substring(1).toUpperCase());
}
